import React from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./admin.css";

import { AdminAuthProvider, useAdminAuth } from "./auth";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";

import AdminLogin from "./pages/AdminLogin";
import Dashboard from "./pages/Dashboard";
import Items from "./pages/Items";
import NotFound from "./pages/NotFound";

function AdminShell() {
  const [current, setCurrent] = React.useState("dashboard");

  return (
    <div className="min-h-screen admin-bg">
      <div className="flex">
        <Sidebar current={current} setCurrent={setCurrent} />

        <main className="flex-1 p-4 lg:p-6">
          <div className="mx-auto max-w-6xl space-y-6">
            <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl p-5">
              <Topbar />
            </div>

            {current === "dashboard" ? <Dashboard /> : null}
            {current === "items" ? <Items /> : null}
          </div>
        </main>
      </div>
    </div>
  );
}

function RequireAdmin({ children }) {
  const { isAuthed, loading } = useAdminAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen admin-bg grid place-items-center">
        <div className="text-white/80">Loading…</div>
      </div>
    );
  }

  if (!isAuthed) {
    return <Navigate to="/admin-login" replace state={{ from: loc.pathname }} />;
  }

  return children;
}

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="/admin-login" element={<AdminLogin />} />

        <Route
          path="/admin"
          element={
            <RequireAdmin>
              <AdminShell />
            </RequireAdmin>
          }
        />

        {/* If you want nested admin routes later */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </AdminAuthProvider>
  );
}
